import { ExternalKeysProviders } from './external-keys-providers.dto';

export enum SecretAuthType {
    Bearer = 'bearer',
    ApiKey = 'api_key',
    Basic = 'basic',
    OAuth2 = 'oauth2',
}

export interface SecretConfig {
    endpoint: string;
    model: string;
    isStreaming: boolean;
    maxMessages?: number;
}

export interface WebhookSecretConfig {
    header_name?: string;
    username?: string;
}

export interface GetExternalKeysResponseDto {
    id: string;
    provider: ExternalKeysProviders;
    type?: SecretAuthType;
    created_at: string;
    modified_at: string;
    last_used_at: string;
    sanitized_secret: string;
    config?: string;
}

export interface SanitizedSecretDto {
    id: string;
    provider: ExternalKeysProviders | string;
    type: SecretAuthType;
    created_at: string;
    modified_at: string;
    last_used_at: string;
    sanitized_secret: string;
    config?: string;
}
